import { h, render, Component } from 'preact';
import TxrNavbar from './txr-navbar';
import { classNames } from '../utils/utils';

class TxrTopDiscountBanner extends Component {

    state = {
        bannerUniqueId: 'txrDiscountBunner',
        isShowButton: true,
        isShow: true
    }
    getBannerClosedKey() {
        return `${this.state.bannerUniqueId}_isClosed`
    }
    componentDidMount() {
        if (window.location.href.includes('pricing') || window.location.href.includes('purchase')) {
            this.setState({isShowButton: false});
        }
       /* setTimeout(() => {
            const isClosed = !!localStorage.getItem(this.getBannerClosedKey()); 
            this.toggle(!isClosed);
        }, 1000);*/
    }
    close() {
        localStorage.setItem(this.getBannerClosedKey(), true);
        this.toggleDelayed(false);
    }
    toggleDelayed(isShow) {
        if(this.state.isShow && !isShow) {
            document.body.classList.add('txr-top-banner-closing');
            setTimeout(() => {
                this.toggle(isShow);
            }, 500);
            return;
        }
        this.toggle(isShow);
    }
    toggle = (isShow) => {
        
        this.setState({ isShow: isShow });
        if (isShow) {
            document.body.classList.add('txr-top-banner-opened');
            document.body.classList.remove('txr-top-banner-closing');
        } else {
            document.body.classList.remove('txr-top-banner-opened');
            document.body.classList.remove('txr-top-banner-closing');
        }
    }
    render() {
        return (
            <div class="txr-top-banner txr-top-discount-banner">
                <div class="txr-top-banner__padding">
                    <img class="banner-image__left" src="/images/navigation/icon-cake.png" alt="" />
                    <div class="banner-middle">
                        <div class="banner-middle__text">
                            New customers — Save big on select plans with code REQUEST20
                        </div>
                        { this.state.isShowButton &&
                            <a class="txr-button-link" href="/pricing">
                                <button class="txr-button txr-action-button txr-small-button" type="button">START SAVING</button>
                            </a>
                        }
                    </div>
                    <img class="banner-image__close" src="/images/navigation/icon-close.svg" onClick={(e) => this.close()} ></img>
                </div>
            </div>
        )
    }
}

export default TxrTopDiscountBanner;